export const DocumentEditorServiceUrl =
  'https://expedo-dev-ae-web-staging.azurewebsites.net/api/document/';

export const TINYMCE_APIKEY = 'zozyl0xsr52trib3dncl1q2jbaii3ww2bc90pv29suh366v7';
